import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo_no_bg from './../media/img/jts_logo.png'
import cancel_icon from './../media/icons/close.png'
import nav_icon from './../media/icons/menu.png'


const NavBar = () => {

    const windowscrollvalue = window.scrollY
    const [showmobilenav, setshowmobilenav] = useState(null)
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            console.log(window.innerWidth)
        };

        const handleScroll = () => {
            // console.log(window.scrollY)
            setshowmobilenav(null)
        }

        window.addEventListener('resize', handleResize);

        window.addEventListener('scroll', handleScroll);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll)
        };
    }, []);

    const handleMobilenav = () => {
        if(!showmobilenav) {
            setshowmobilenav(true)
        } else {
            setshowmobilenav(false)
        }
    }



    return ( 
        <>
            <header>
                
            </header>

            

        </>
    );
}
 
export default NavBar;